import { Location } from 'vue-router';

export interface ServiceLocation {
  toServiceLocation: (
    params: { appType: string },
  ) => Location;
  toMentalCounselingLocation: () => Location;
  toMentalConsultationLocation: () => Location;
}

export const useServiceLocation = (): ServiceLocation => {
  const toServiceLocation = (params): Location => {
    return {
      name: 'service-custom',
      params,
    };
  };

  const toMentalCounselingLocation = (): Location => {
    return {
      name: 'mental-counseling',
    };
  };

  const toMentalConsultationLocation = (): Location => {
    return {
      name: 'mental-consultation',
    };
  };

  return {
    toServiceLocation,
    toMentalCounselingLocation,
    toMentalConsultationLocation,
  };
};
